import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import UserAIDescriptionsData from "./user-ai-descriptions-data";
import UserAIDescriptionsForm from "./user-ai-descriptions-form";

const UserAIDescriptions = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "USER_AI_DESCRIPTIONS",
      "USER_AI_DESCRIPTIONS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("AI_DESCRIPTIONS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserAIDescriptionsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserAIDescriptionsData />
    </ET3PageDiv>
  );
});

export default UserAIDescriptions;
